goog.provide("shadow.js.shim.module$src$svg$wpp$content$cloud_svg$default");
shadow.js.shim.module$src$svg$wpp$content$cloud_svg$default = shadow.js.shim.module$src$svg$wpp$content$cloud_svg.default;
